/**
 * Strings for the Agent application.
 * Localized for French.
 */
export default {

  // Single word strings.
  Addagent: 'French Add Agent',
  Brand: 'French Live Support - Agent',
  Login: 'French Login',
  No: 'French No',
  Password: 'French Password',
  Save: 'French Save',
  Username: 'French Username',
  Yes: 'French Yes',
  Send: 'French Send',
  timeFormat: 'DD/MM/YYYY, h:mm A',

  confirmPassword: 'French Confirm Password',
  editProfileLabel: 'French Edit Profile',
  firstName: 'French First Name',
  lastName: 'French Last Name',

  // CustomerPanel component
  CustomerPanel: {
    anonymous: 'French Anonymous',
    blankEmail: 'French Email not provided',
    requestType: 'French Request type',
    customerContext: 'French Customer Context',
    detailsUnavailable: 'French Call details unavailable.',
    getNext: "French Click 'Get Next' to get a customer from the queue.",
    ipUnavailable: 'French IP Unavailable',
    noContext: 'French No context Povided'
  },

  // CustomerSidebar component
  CustomerSidebar: {
    customersWaiting: 'French Customers waiting',
    getNext: 'French Get Next',
    getRequestError: 'French Failed to fetch next service request.',
    noCustomers: 'French No customers in the queue.',
    noFilteredRequests: 'French No customers in the selected filter.',
    activeCustomers: 'French Active Customers',
    voiceChatRequests: 'French Voice Chat Requests',
    textChatRequests: 'French Text Chat Requests',
    videoChatRequests: 'French Video Chat Requests'
  },

  // Customer component
  Customer: {
    callRequested: 'French Call Requested',
    anonymous: 'French Anonymous',
    min: 'French min'
  },

  // Agent Sidebar component
  AgentSidebar: {
    otherAgents: 'French Other Agents'
  },

  // Session Component
  Session: {
    end: 'French End Session',
    start: 'French Start Session'
  },

  // Call Component
  Call: {
    answerCallFailure: 'French Failed to answer call',
    endCallFailure: 'French Failed to end call',
    initCallFailure: 'French Failed to initiate call',
    rejectCallFailure: 'French Failed to reject call',
    startScreenShareFailure: 'French Failure to start screensharing',
    stopScreenShareFailure: 'French Failure to stop screensharing',
    screenShareError: 'French Screensharing Error',
    screenShareErrorMessage: 'French Screen Sharing is supported only in chrome. For extension',
    startScreenShare: 'French Start Share',
    stopScreenShare: 'French Stop Share',

    answer: 'French Answer Call',
    call: 'French Call',
    decline: 'French Decline Call',
    end: 'French End Call',
    hold: 'French Hold',
    mute: 'French Mute',
    startVideo: 'French Start Video',
    stopVideo: 'French Stop Video',
    screenShareError: 'French Screensharing Error',
    unHold: 'French UnHold',
    unMute: 'French UnMute'
  },

  // Chat Component
  Chat: {
    placeholder: 'French Type here to send a chat message...'
  },

  // Chat Message Component
  ChatMessage: {
    media: 'French Media'
  },

  // Notice messages.
  Notices: {
    // Login container.
    invalidCredentials: 'French Invalid credentials.',
    wait: 'French Please wait...',

    // EditProfile container.
    updateAgtDetailsError: 'French Error in updating Agent Details.',
    updatedAgtDetails: 'French Agent Details Updated.',
    updatingAgtDetails: 'French Updating...',

    // Admin Container
    createdAgent: 'French Agent created on Kandy-Portal. Please do not edit any details over there.',
    creatingAgent: 'French Please wait while agent is being created...',
    userCreateError: 'French Agent could not be created',

    // Session Component
    endCall: 'French Please end the call before ending the session.',

    // Dashboard container
    loggingIn: 'French Logging in...'
  },

  Navigation: {
    addAgent: 'French Add Agent',
    dashboard: 'French Dashboard',
    logout: 'French Logout',
    profile: 'French Profile'
  },

  Validations: {
    passwordMismatch: 'French Password and Confirm password do not match.',
    username: 'French Username is mandatory'
  }
}
